import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Opens every new page at its top (MYP-118). `BrowserRouter` keeps the window where it was, so
 * "New order" pressed far down the Packages list used to open the order page part-way down.
 * React Router's own `ScrollRestoration` only works with its data routers, hence this.
 *
 * Only the path counts: filters, tabs and panels live in the query string (`?status=`,
 * `?panel=add`) and must not jump the page. Back/Forward (`POP`) is left to the browser, which
 * puts the reader back where they were.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  const previous = useRef(pathname);

  useEffect(() => {
    if (previous.current === pathname) return;
    previous.current = pathname;
    if (navigationType !== 'POP') window.scrollTo({ top: 0 });
  }, [pathname, navigationType]);

  return null;
}
